/* DigitalPower — страница „Запитване“ (dp-inquiry, dp-contact-cta). Без библиотеки.
   Зарежда се от секциите с defer, затова се изпълнява ПРЕДИ dp.js (който е в края на body). */
(function () {
  'use strict';
  if (window.__dpContact) return;
  window.__dpContact = true;

  var FORM_ID = 'dp-inquiry-form';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getForm() { return document.getElementById(FORM_ID); }
  function getRoot() { var f = getForm(); return f && f.closest('[data-inq-root]'); }

  /* 1. И модалът, и тази форма са Shopify „contact“ форми. След изпращане Shopify маркира и двете
        като posted_successfully, а dp.js отваря модала автоматично. Щом формата е на страницата,
        махаме маркера преди dp.js да го види — успехът се показва в самата форма. */
  if (getForm()) {
    document.querySelectorAll('[data-dp-modal] [data-dp-modal-autopen]').forEach(function (el) {
      el.parentNode.removeChild(el);
    });
  }

  function scrollToForm(focus) {
    var root = getRoot();
    if (!root) return;
    var card = root.querySelector('[data-inq-card]') || root;
    var y = card.getBoundingClientRect().top + window.pageYOffset - 24;
    window.scrollTo({ top: Math.max(0, y), behavior: reduce ? 'auto' : 'smooth' });
    if (!focus) return;
    var form = getForm();
    var fields = form.querySelectorAll('[data-inq-fields]:not([hidden]) input:not([type="hidden"]):not([type="radio"]), [data-inq-fields]:not([hidden]) textarea');
    var target = null;
    for (var i = 0; i < fields.length; i++) { if (!fields[i].value) { target = fields[i]; break; } }
    if (target) setTimeout(function () { target.focus({ preventScroll: true }); }, reduce ? 0 : 650);
  }

  /* 2. „Запитване“ бутоните (хедър, док, CTA) водят към формата вместо към модала */
  var root0 = getRoot();
  if (root0 && root0.hasAttribute('data-inq-scroll')) {
    window.addEventListener('click', function (e) {
      if (!e.target.closest) return;
      var a = e.target.closest('a[href="#zapitvane"], a[href$="#zapitvane"], [data-dp-modal-open]');
      if (!a || a.closest('[data-dp-modal]') || !getForm()) return;
      e.preventDefault();
      e.stopPropagation();
      scrollToForm(true);
    }, true);
    /* „Попитай ни“ (dp-ask) попълва формата на страницата вместо модала. dp.js дефинира
       dpOpenInquiry по-късно, затова го пренасочваме след като всички defer скриптове са минали. */
    document.addEventListener('DOMContentLoaded', function () {
      window.dpOpenInquiry = function (text) {
        var form = getForm();
        var ta = form && form.querySelector('textarea[name="contact[body]"]');
        if (text && ta && !ta.value) ta.value = text;
        scrollToForm(true);
      };
    });
  }

  /* 3. След изпращане (успех или грешка) — покажи формата */
  if (root0 && root0.querySelector('[data-inq-status]')) {
    window.addEventListener('load', function () { setTimeout(function () { scrollToForm(false); }, 60); });
  }

  /* 4. Делегирани събития — оцеляват при презареждане на секцията в Customize */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    /* Ново запитване след успех */
    var again = e.target.closest('[data-inq-again]');
    if (again) {
      var r = again.closest('[data-inq-root]');
      var done = r.querySelector('[data-inq-done]');
      var fields = r.querySelector('[data-inq-fields]');
      done.hidden = true;
      fields.hidden = false;
      var f = getForm();
      if (f) f.reset();
      if (window.history && history.replaceState) history.replaceState(null, '', location.pathname);
      var first = fields.querySelector('input:not([type="hidden"]):not([type="radio"])');
      if (first) first.focus();
      return;
    }

    /* Копиране на имейл */
    var copy = e.target.closest('[data-copy]');
    if (copy) {
      var text = copy.getAttribute('data-copy');
      var live = copy.parentNode.querySelector('[data-copy-live]');
      var ok = function () {
        copy.classList.add('is-copied');
        if (live) live.textContent = (copy.querySelector('.dp-ccta__copy-done') || {}).textContent || '';
        clearTimeout(copy._t);
        copy._t = setTimeout(function () {
          copy.classList.remove('is-copied');
          if (live) live.textContent = '';
        }, 1800);
      };
      var fallback = function () { window.location.href = 'mailto:' + text; };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(ok, fallback);
      } else {
        fallback();
      }
    }
  });

  /* Незадължителен избор: второ докосване на избран чип го маха */
  var lastChip = null;
  document.addEventListener('click', function (e) {
    var input = e.target;
    if (!input || input.type !== 'radio' || !input.closest('[data-inq-chips="optional"]')) return;
    if (lastChip === input && input._wasChecked) {
      input.checked = false;
      lastChip = null;
    } else {
      lastChip = input;
    }
  });
  document.addEventListener('pointerdown', function (e) {
    var label = e.target.closest && e.target.closest('.dp-inq__chip');
    var input = label && label.querySelector('input[type="radio"]');
    if (input) input._wasChecked = input.checked;
  });

  /* Изпращане: състояние на бутона + Meta Pixel Lead (веднъж) */
  var leadSent = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.id !== FORM_ID || !form.checkValidity()) return;
    var btn = form.querySelector('.dp-inq__submit');
    if (btn) {
      btn.classList.add('is-loading');
      setTimeout(function () { btn.classList.remove('is-loading'); }, 8000);
    }
    if (!leadSent && window.fbq) {
      leadSent = true;
      window.fbq('track', 'Lead', { content_name: 'inquiry_page' });
    }
  });
})();
